/* eslint-disable fp/no-unused-expression, no-undef*/
'use strict'
const layoutUtils = require('carmi-host-extensions/src/layout/layoutUtils')
const {BEATS} = require('bolt-main/src/bi/constants')

module.exports = logger => ({publicModel, rendererModel, serviceTopology, requestModel}, setSsrSucceeded, setServerMarkup, warmupDoneCallback, reportBeatEvent) => {
    const _ = requirejs('lodash')
    const warmupUtils = requirejs('warmupUtils')
    const $ = requirejs('zepto')
    const {indicator, constants, urlUtils} = warmupUtils
    const shouldShowDebugInformation = warmupUtils.shouldShowDebugInformation()

    window.sssr = {} // TODO † jesus †, let's not copy this naming to bolt

    $(() => {
        const ssrReturnedBody = !_.isUndefined(window.clientSideRender)
        if (!ssrReturnedBody) {
            window.clientSideRender = true
            window.santaRenderingError = {
                errorInfo: constants.BODY_NOT_RENDERED_ERR,
                reason: constants.BODY_NOT_RENDERED_ERR
            }

            const siteContainer = window.document.createElement('DIV')
            siteContainer.setAttribute('id', 'SITE_CONTAINER')
            window.document.body.appendChild(siteContainer)
        }

        const ssrSucceeded = window.clientSideRender === false

        indicator.init('Bolt', () => {
            switch (indicator.getState()) {
                case indicator.STATES.PREWARMUP:
                    warmup()
                    break
                case indicator.STATES.STANDBY:
                    indicator.updateState(indicator.STATES.RENDERING)
                    warmupSuccess()
                    break
                default:
                    return
            }
        })

        if (!urlUtils.isTrue('ssrPrewarmupOnly')) {
            warmup()
        }

        function warmup() {
            if (!ssrSucceeded) {
                indicator.updateStateOnClientSide()

                if (window.santaRenderingError && shouldShowDebugInformation) {
                    const errorInfo = _.get(window.santaRenderingError, 'errorInfo', '')
                    const message = '%cUnable to render using Server Side Rendering. Defaulting to client-side render.'
                    const messageStyle = 'color: red; font-size: large'
                    console.error(message, messageStyle)
                    console.error(`Reason: ${errorInfo}`)
                }

                console.timeEnd('warmup')
                warmupDoneCallback()
                return
            }

            const serverMarkup = window.document.getElementById('SITE_CONTAINER').innerHTML
            setServerMarkup(serverMarkup)

            const {layoutData: layoutWarmupData} = window.warmupData

            if (layoutWarmupData) {
                const layout = requirejs('layout')
                _.assign(rendererModel.runningExperiments, {sv_meshLayout: 'new'}) //TODO @santa-ssr - remove once mesh is opened, hack for running layout with mesh
                const layoutData = _.assign({}, layoutWarmupData, {publicModel, rendererModel, serviceTopology, requestModel, primaryPageNavigationInfo: warmupData.rootNavigationInfo})

                const {runLayout} = layoutUtils.init(layoutData, {warmupUtils, layout, lodash: _}, true, logger)
                runLayout({isPageAllowed: layoutData.isPageAllowed}, afterLayout, true)
            } else {
                afterLayout()
            }
        }

        function afterLayout() {
            $('body').removeClass('prewarmup')
            const {beatNumber, eventName} = BEATS.DONE_WARMUP
            reportBeatEvent(beatNumber, eventName)
            indicator.updateState(indicator.STATES.WARMUP)
            if (urlUtils.isTrue('ssrWarmupOnly')) {
                indicator.updateState(indicator.STATES.STANDBY)
            } else {
                warmupSuccess()
            }
        }

        function warmupSuccess() {
            setSsrSucceeded(true)
            warmupDoneCallback()
        }
    })
}
